import Box from "../Box";
import { Skeleton } from "../Skeleton";
import {
	PODIUM_BLOCK_BEVEL_HEIGHT,
	PODIUM_BLOCK_HEIGHTS,
} from "./LeaderboardPodiumBlock";
import { PODIUM_CARD_HEIGHTS } from "./LeaderboardPodiumCard";
import {
	PODIUM_CHART_HEIGHT,
	PODIUM_CHART_MAX_WIDTH,
} from "./LeaderboardPodiumChart";

const PLACES = [2, 1, 3] as const;

const AVATAR_SIZES: Record<(typeof PLACES)[number], number> = {
	1: 60,
	2: 46,
	3: 46,
};

const TEXT_LINE_HEIGHTS: Record<(typeof PLACES)[number], number> = {
	1: 20,
	2: 16,
	3: 16,
};

export const LeaderboardPodiumSkeleton = () => (
	<Box
		flexDirection="row"
		alignItems="flex-end"
		minHeight={PODIUM_CHART_HEIGHT}
		width="100%"
		style={{
			maxWidth: PODIUM_CHART_MAX_WIDTH,
			marginHorizontal: "auto",
		}}
	>
		{PLACES.map((place) => (
			<Box key={place} flex={1} minHeight={PODIUM_CARD_HEIGHTS[place]}>
				<Box
					flex={1}
					gap={4}
					alignItems="center"
					justifyContent="center"
					paddingBottom={8}
				>
					<Skeleton size={AVATAR_SIZES[place]} variant="circle" />
					<Skeleton width={64} height={TEXT_LINE_HEIGHTS[place]} />
					<Skeleton width={40} height={TEXT_LINE_HEIGHTS[place]} />
				</Box>
				<Skeleton
					width="100%"
					height={PODIUM_BLOCK_HEIGHTS[place] + PODIUM_BLOCK_BEVEL_HEIGHT}
					borderRadius={0}
				/>
			</Box>
		))}
	</Box>
);
